import LinkWrapper from "../../../../elements/link-wrapper/link-wrapper";
import { TFeatureLink } from "../../header-v2";
import styles from "./mobile-featured-link.module.less";

const MobileFeaturedLink = ({ title, url, icon }: TFeatureLink) => {
  return (
    <LinkWrapper className={styles.wrapper} url={url}>
      {icon && <span className={[styles.icon, icon].join(" ")} />}
      <p className={[styles.title, "body-base mb-0"].join(" ")}>{title}</p>
    </LinkWrapper>
  );
};

export default MobileFeaturedLink;
